/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "./Link";

/** One item of a directory's card view; its title's link makes the whole card the target. */
export function DirectoryCard({
  to,
  title,
  subtitle,
  footer,
  footerEnd,
  children,
}: {
  to: string;
  title: ReactNode;
  subtitle: ReactNode;
  footer: ReactNode;
  footerEnd?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <li className="group relative flex h-full flex-col gap-3 rounded-3xl border border-border bg-bg-elevated p-5 shadow-card lift">
      <div className="min-w-0">
        <h2 className="truncate font-display text-xl leading-tight text-text-primary">
          <Link to={to} className="after:absolute after:inset-0 after:rounded-3xl">
            {title}
          </Link>
        </h2>
        <p className="mt-0.5 truncate text-xs text-text-tertiary">{subtitle}</p>
      </div>
      {children}
      <div className="mt-auto flex items-center justify-between gap-3 text-xs text-text-tertiary">
        <span className="truncate">{footer}</span>
        <span className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap">
          {footerEnd}
          <ChevronRight size={16} className="text-text-tertiary transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </li>
  );
}
